// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"1779":"error","4358":"doctor-appointment","4669":"modal-reservasi-dokter"}[chunkId] || chunkId) + "." + {"795":"2524ac56","1779":"fbeb9805","4358":"5357a4d5","4669":"a4fa767b","8047":"52022bf6"}[chunkId] + ".css";
};